import Cookies from "js-cookie";
import { atom } from "recoil";

export type UserType = {
  loggedUser?: {
    name?: string;
    v_uid: string;
  };
  token: string;
  userInfo?: string;
};

export const userState = atom<UserType>({
  key: "userState",
  default: {
    token: Cookies.get("dcuser") || "",
  },
});
